import { Injectable } from '@angular/core';
import { SquareOrderError } from '../store/square-orders-errors.models';

const ERROR_TRUNCATE_LENGTH = 120;

@Injectable({
    providedIn: 'root',
})
export class SquareOrdersErrorsAdapterService {

    adapt(raw: any): SquareOrderError {
        const fullError: string = raw.error ?? '';
        const shortError =
            fullError.length > ERROR_TRUNCATE_LENGTH
                ? fullError.substring(0, ERROR_TRUNCATE_LENGTH) + '...'
                : fullError;

        return {
            id: raw.id,
            error: shortError,
            error_full: fullError,
            is_resolved: raw.is_resolved ?? false,
            square_order_id: raw.square_order?.square_order_id ?? '',
            venue: raw.venue?.name ?? '',
            playdate: raw.playdate?.date ?? '',
            square_order: raw.square_order,
            playdate_obj: raw.playdate,
            venue_obj: raw.venue,
        };
    }

    adaptList(rawList: any[]): SquareOrderError[] {
        return (rawList ?? []).map((item) => this.adapt(item));
    }
}
